<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ArgonButton from "@/components/ArgonButton.vue";
// import ArgonButton from "@/components/ArgonButton.vue";

const body = document.getElementsByTagName("body")[0];

const store = useStore();

onMounted(() => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip();
});
onBeforeMount(() => {
  body.classList.add("profile-overview");
});
onBeforeUnmount(() => {
  body.classList.remove("profile-overview");
});
</script>
<template>
  <div class="card mb-4">
    <div class="card-header pb-4">
      <h6>Tiendas</h6>
      <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="success"
                  size="sm"
                  @click.prevent="altaStore"
                  >Alta</argon-button
  >
    </div>
    <div v-if="false" class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
    <div class="card-body px-0 pt-0 pb-2" v-else>
      <div class="table-responsive p-0">
        <table class="table align-items-center justify-content-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >
                Id Tienda
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Nombre Tienda
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Contacto
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Tel de Contacto
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Direccion
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Status
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Fecha de creacion
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                Accion
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="store in tiendas" :key="store.id">
              <td>
                <div class="d-flex px-2">
                  <div class="my-auto">
                    <h6 class="mb-0 text-sm">{{ store.id }}</h6>
                  </div>
                </div>
              </td>
              <td>
                <p class="text-sm font-weight-bold mb-0">{{ store.nombre }}</p>
              </td>
              <td>
                <p class="text-sm font-weight-bold mb-0">
                  {{ store.contacto }}
                </p>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{ store.tel }}</span>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{ store.direccion }}</span>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{ store.status }}</span>
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{
                  store.fechaCreacion
                }}</span>
              </td>
              <td>
                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="info"
                  fullWidth
                  size="sm"
                  @click.prevent="updatestore(store)"
                  >Actualizar</argon-button
                >
              </td>
            </tr>
          </tbody>
        </table>
         
          <argon-pagination
            color="info"
            size="lg"
            class="justify-content-center"
          >
            <!-- Botón anterior -->
            <argon-pagination-item
              prev
              :disabled="paginaActual === 1"
              @click.native="getStores(paginaActual - 1)"
            />

            <!-- Páginas -->
            <argon-pagination-item
              v-for="n in totalPaginas"
              :key="n"
              :active="paginaActual === n"
              :label="n.toString()"
              @click.native="getStores(n)"
            />
            <argon-pagination-item
              next
              :disabled="paginaActual === totalPaginas"
              @click.native="getStores(paginaActual + 1)"
            />
          </argon-pagination>
        
      </div>
      <updateTienda v-if="storeUpdate" :miStore="storeUpdate" />
      <altaTienda v-if="alta" />
    </div>
  </div>
</template>
<script>

import updateTienda from "../UpdateTienda.vue";
import altaTienda from "../AltaTienda.vue";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import stores from "../../api/stores";
import Swal from "sweetalert2";
export default {
  components: { altaTienda, updateTienda,ArgonPagination, ArgonPaginationItem},
  data() {
    return {
      loading: true,
      status: null,
      token: "",
      tiendas: [],
      storeUpdate: null,
      paginaActual: 1,
      totalPaginas: 1,
      alta:false
    };
  },
  onMounted() {},
  created() {
    this.token = localStorage.getItem("token");
    this.getStores(1);
    
  },
  methods: {
    async getStores(pagina) {
      
      this.storeUpdate=null
      this.alta=false
      if(pagina>this.totalPaginas){
        pagina = this.totalPaginas
      }
      this.paginaActual=pagina
      stores
        .getStores({ token: this.token, pagina: this.paginaActual })
        .then((result) => {
          
          if (result.data.stores != null) {
            this.tiendas = result.data.stores;
            this.paginaActual = result.data.pagina_actual;
            this.totalPaginas = result.data.total_paginas;
            this.loading = false
          } else {
            Swal.fire({
              title: "Error al obtener stores",
              text: result.data.error,
              icon: "error",
              confirmButtonColor: "error",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async updatestore(store) {
      this.storeUpdate = store;
    },
    altaStore(){
      this.alta = true
    }
  },
};
</script>
